import { render } from "./Options.vue?vue&type=template&id=f283e732"
import script from "./Options.vue?vue&type=script&lang=js"
export * from "./Options.vue?vue&type=script&lang=js"

import "./Options.vue?vue&type=style&index=0&id=f283e732&lang=scss"
script.render = render

export default script